import { render, staticRenderFns } from "./frontUploadFile.vue?vue&type=template&id=408a8738&"
import script from "./frontUploadFile.vue?vue&type=script&lang=js&"
export * from "./frontUploadFile.vue?vue&type=script&lang=js&"
import style0 from "./frontUploadFile.vue?vue&type=style&index=0&id=408a8738&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports